import { DynamicTranslations } from './dynamic-translations'

export interface StructureTranslationsInterface {
  /**
   * 翻译列表
   */
  name?: DynamicTranslations
}

export class StructureTranslations implements StructureTranslationsInterface {
  /**
   * 翻译列表
   */
  name?: DynamicTranslations

  constructor(props: StructureTranslationsInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      name: _name,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.name = _name ? new DynamicTranslations(_name) : _name
  }
}
